import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Legend,
} from "recharts";

const data = [
  { name: "Apr", value1: 400, value2: 150 },
  { name: "May", value1: 1010, value2: 218 },
  { name: "Jun", value1: 303, value2: 120 },
  { name: "Jul", value1: 450, value2: 628 },
  { name: "Aug", value1: 700, value2: 137 },
  { name: "Sept", value1: 135, value2: 215 },
  { name: "0ct", value1: 150, value2: 300 },
];

function LineCharts() {
  return (
    <div>
      <div
        style={{
          color: "#3A3A3A",
          fontFamily: "Nunito",
          fontSize: "17px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "26.4px",
          paddingTop: "10px",
          paddingLeft: "25px",
        }}
      >
        Activities
      </div>
      <ResponsiveContainer width="99%" height={350}>
        <LineChart
          data={data}
          margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        >
          <CartesianGrid stroke="#F3F4F6" />
          <XAxis dataKey="name" />
          <YAxis />
          <Legend />
          <Line
            type="monotone"
            dataKey="value1"
            stroke="#FAC800"
            strokeWidth={3.273}
            dot={false}
            name="Transfers"
            // isAnimationActive={false}
          />
          <Line
            type="monotone"
            dataKey="value2"
            stroke="#5523D2"
            strokeWidth={3.273}
            dot={false}
            name="Deposits"
            // isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default LineCharts;
